import Agent from "infrastructure/agent";
import { GroupMapper } from "features/planner/planner.mappers";
import appService from "services/app.service";

/**
 * Group
 */
const getGroups = includeDeleted =>
  Agent.get(`/group${includeDeleted ? "/true" : ""}`);

const getGroup = groupId => Agent.get(`/group/${groupId}`);

const createGroup = group => Agent.post(`/group`, GroupMapper.to(group));

const updateGroup = (groupId, group) =>
  Agent.put(`/group/${groupId}`, GroupMapper.to(group));

const deleteGroup = groupId => Agent.delete(`/group/${groupId}`);

/**
 * Card moves
 */
const addEmployeeCardsToPlanningGroup = (groupId, cardIds) =>
  Agent.post(`/group/${groupId}/cardmoves`, cardIds);

/**
 * Misc
 */
const getGroupCardsCompetencyStatus = groupId =>
  Agent.get(`/group/${groupId}/cards/competencystatus`);

const getReplacableEmployees = groupId =>
  Agent.get(`/group/${groupId}/replaceableemployees`);

const updateGroupFlagType = (groupId, flagType) =>
  Agent.post(`/group/${groupId}/flag/${flagType}`);

const getGroupOpenDeployments = groupId =>
  Agent.get(`/group/${groupId}/deployments/current`);

const createCompanyGroupRelation = (groupId, companyrelation) =>
  Agent.post(`/group/${groupId}/companyrelations`, companyrelation);

const getCompanyGroupRelations = groupId =>
  Agent.get(`/group/${groupId}/companyrelations`);

const groupExists = group => Agent.post(`/group/exists`, group);

const undeleteGroup = groupId => Agent.post(`/group/${groupId}/undelete`);

const redirectToSpecificationGapReport = groupId =>
  appService.openApiUrl(`/group/${groupId}/competencystatus/redirect`);

export default {
  getGroup,
  getGroups,
  groupExists,
  createGroup,
  updateGroup,
  updateGroupFlagType,
  deleteGroup,
  getGroupCardsCompetencyStatus,
  getReplacableEmployees,
  getGroupOpenDeployments,
  createCompanyGroupRelation,
  getCompanyGroupRelations,
  addEmployeeCardsToPlanningGroup,
  undeleteGroup,
  redirectToSpecificationGapReport,
};
